/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What WPM do employers expect from a 3-minute test?`)
};

const es_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué WPM esperan los empleadores en un test de 3 minutos?`)
};

const de_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche WPM erwarten Arbeitgeber bei einem 3-Minuten-Test?`)
};

const nl_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke WPM verwachten werkgevers bij een test van 3 minuten?`)
};

const fr_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel WPM les employeurs attendent-ils pour un test de 3 minutes ?`)
};

const it_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che WPM si aspettano i datori di lavoro da un test da 3 minuti?`)
};

const pt_br2_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que WPM os empregadores esperam em um teste de 3 minutos?`)
};

const pt_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que WPM esperam os empregadores de um teste de 3 minutos?`)
};

const ja_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3分間のテストで、企業はどのくらいのWPMを求めていますか？`)
};

const zh_typing_u3_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雇主对3分钟测试的WPM有什么期望？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u3_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u3_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u3_faq4_q", locale)
	if (locale === "en") return en_typing_u3_faq4_q(inputs)
	if (locale === "es") return es_typing_u3_faq4_q(inputs)
	if (locale === "de") return de_typing_u3_faq4_q(inputs)
	if (locale === "nl") return nl_typing_u3_faq4_q(inputs)
	if (locale === "fr") return fr_typing_u3_faq4_q(inputs)
	if (locale === "it") return it_typing_u3_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u3_faq4_q(inputs)
	if (locale === "pt") return pt_typing_u3_faq4_q(inputs)
	if (locale === "ja") return ja_typing_u3_faq4_q(inputs)
	return zh_typing_u3_faq4_q(inputs)
};